import { client } from "./request";

export interface SaveEstimateTemplateCommand {
  id?: string;
  title: string;
  items: SaveEstimateTemplateCommandItem[];
  documentId?: string | number;
}

export interface SaveEstimateTemplateCommandItem {
  expenseCategoryId: string;
  unitName: string;
  unitType: string;
  unitPrice: number;
  unitLoss: number;
  amount: number;
  memo: string;
  items?: SaveEstimateTemplateCommandItem[];
}

/**
 * 見積テンプレートを保存する
 */
export async function saveEstimateTemplate(
  command: SaveEstimateTemplateCommand
): Promise<void> {
  await client.post("save_estimate_template.php", command);
}

export interface EstimateTemplate {
  id: string;
  title: string;
  items: EstimateTemplateItem[];
}

export interface EstimateTemplateItem {
  id: string;
  expenseCategoryId: string;
  unitName: string;
  unitType: string;
  unitPrice: number;
  unitLoss: number;
  amount: number;
  memo: string;
  items?: EstimateTemplateItem[];
}

export async function getEstimateTemplate(
  id: string
): Promise<EstimateTemplate | null> {
  return await client.get(`get_estimate_template.php?id=${id}`);
}

export async function getEstimateTemplates(
  documentId = null
): Promise<EstimateTemplate[]> {
  return await client.get("get_estimate_templates.php", { documentId });
}

export async function deleteEstimateTemplate(id: string): Promise<void> {
  const data = new FormData();
  data.append("id", id);
  await client.post("delete_estimate_template.php", data);
}
